import "./ProductSelection.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import SelectionHero from "./sections/SelectionHero";
import SelectionGuides from "./sections/SelectionGuides";
import FilterSizingMethodology from "./sections/FilterSizingMethodology";
import Articles from "./sections/Articles";
import QuoteCta from "./sections/QuoteCta";
import ComparisonHighlights from "./sections/ComparisonHighlights";
import Footer from "@/reusable_sections/Footer";
export default function ProductSelectionPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="ProductSelection" />
      <SelectionHero />
      <SelectionGuides />
      <FilterSizingMethodology />
      <Articles />
      <ComparisonHighlights />
      <QuoteCta />
      <Footer />
    </div>;
}